module.exports = __webpack_public_path__ + "static/media/neal-e-johnson-1541065-unsplash.e0e41621.jpg";